export { Image } from './image.component'
